/**
 * @ngdoc services
 * @memberof mercury.modules.time.payroll.paytypes.leave
 * @name TimePayrollLeave
 * @description Data access service for managing holiday pay and leave types
 */
angular.module('mercury.modules.time.payroll.paytypes.leave')
.factory('TimePayrollLeave', ["$resource", "$http", "$q", "settings", function($resource, $http, $q, settings) {
  var Paytypes = $resource(settings.apiHost + '/r/TimePayrollPaytypes/:id', {id: '@id'});

  /**
   * Get a list of all allowances
   *
   * @memberof TimePayrollAllowance
   */
  function getAll() {
    return Paytypes.query({module: 2}).$promise;
  }

  /**
   * Update or create a given allowance
   *
   * @memberof TimePayrollAllowance
   * @param  {Object} allowance Allowance model
   */
  function save(allowance) {
    allowance.module = 2;
    if (allowance.id) {
      return Paytypes.update(allowance).$promise;
    } else {
      return Paytypes.save(allowance).$promise;
    }
  }

  /**
   * Get the Average daily rate for the given staff member
   *
   * @memberof TimePayrollAllowance
   * @param  {string}  staffId Id of staff member to get average pay for
   * @param {datetime} date Get average pay over the 52 weeks ending at this date
   */
  function getAveragePay(staffId, date) {
    if (!staffId || !date) {
      return $q.resolve({data: 0});
    }
    return $http.get(settings.apiHost + '/r/TimePayrollAverageDailyPay', {
      params: {staffId: staffId, date: date.format()}
    });
  }

  return {
    getAll: getAll,
    save: save,
    getAveragePay: getAveragePay
  };
}]);
